import { BankType, DebtType } from '../generated/graphql';

export const getDebtTypeLabel = (type: DebtType | string, bank?: BankType | string) => {
  if (bank === BankType.MovistarMoney) return 'Factura';
  switch (type) {
    case DebtType.Unclassified: return 'Crédito';
    case DebtType.CreditCard: return 'Tarjeta de Crédito';
    case DebtType.AllPurpose: return 'Libre inversión';
    case DebtType.Vehicle: return 'Vehículo';
    case DebtType.Virtual: return 'Unificación de deudas';
    case DebtType.PayrollAdvance: return 'Adelanto de nómina';
    case DebtType.Housing:
    case DebtType.Mortgage: return 'Hipotecario';
    case DebtType.Leasing: return 'Leasing';
    case DebtType.Factoring: return 'Factoring';
    case DebtType.Informal: return 'Informal';
    case DebtType.Revolving: return 'Rotativo';
    case DebtType.Services: return 'Telecomunicaciones';
    case DebtType.Overdraft: return 'Sobregiro';
    case DebtType.Payroll: return 'Libranza';
    case DebtType.Rediscount: return 'Redescuento';
    case DebtType.CommercialLoan: return 'Crédito comercial';
    case DebtType.ConsumerLoan: return 'Crédito de consumo';
    case DebtType.Rr: return 'Servicio Hogar';
    case DebtType.Bscs: return 'Servicio Móvil';
    case DebtType.Ascard: return 'Equipos financiados';
    case DebtType.Sga: return 'Servicio empresarial';
    default: return type;
  }
};
